import styled from 'styled-components';

export const LegalLinksWrapper = styled.div`
  a, a:hover, a:visited {
    justify-content: left;
    border: none
  }
`;